import { render, staticRenderFns } from "./MatchingCheck.vue?vue&type=template&id=99821698&scoped=true"
import script from "./MatchingCheck.vue?vue&type=script&lang=js"
export * from "./MatchingCheck.vue?vue&type=script&lang=js"
import style0 from "./MatchingCheck.vue?vue&type=style&index=0&id=99821698&prod&scoped=true&lang=scss&media=print"
import style1 from "./MatchingCheck.vue?vue&type=style&index=1&id=99821698&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99821698",
  null
  
)

export default component.exports